export const animation = "drop";
export const duration = 450;
export const allowed = [
  ".pdf",
  "image/*",
  ".xlsx",
  ".xls",
  ".doc",
  ".docx",
  ".ppt",
  ".pptx",
];

export const canvasWidth = 3000;
export const noiseAmount = 5;
export const noiseSpeed = 0.004;
export const scrollSpeed = 0.3;
export const contentOptions = [
  { key: 1, text: "Image", value: "image/*" },
  { key: 2, text: "Video", value: "video/*" },
];
export const bubbles = [
  {
    s: 0.6,
    x: 1134,
    y: 45,
  },
  {
    s: 0.6,
    x: 1620,
    y: 271,
  },
  {
    s: 0.6,
    x: 1761,
    y: 372,
  },
  {
    s: 0.6,
    x: 2499,
    y: 79,
  },
  {
    s: 0.8,
    x: 2704,
    y: 334,
  },
  {
    s: 0.6,
    x: 2271,
    y: 356,
  },
  {
    s: 0.6,
    x: 795,
    y: 226,
  },
  {
    s: 0.6,
    x: 276,
    y: 256,
  },
  {
    s: 0.6,
    x: 1210,
    y: 365,
  },
  {
    s: 0.6,
    x: 444,
    y: 193,
  },
  {
    s: 0.6,
    x: 2545,
    y: 387,
  },
  {
    s: 0.8,
    x: 1303,
    y: 193,
  },
  {
    s: 0.8,
    x: 907,
    y: 88,
  },
  {
    s: 0.8,
    x: 633,
    y: 320,
  },
  {
    s: 0.8,
    x: 323,
    y: 60,
  },
  {
    s: 0.8,
    x: 129,
    y: 357,
  },
  {
    s: 0.8,
    x: 1440,
    y: 342,
  },
  {
    s: 0.8,
    x: 1929,
    y: 293,
  },
  {
    s: 0.8,
    x: 2135,
    y: 198,
  },
  {
    s: 0.8,
    x: 2276,
    y: 82,
  },
  {
    s: 0.8,
    x: 2654,
    y: 182,
  },
  {
    s: 0.8,
    x: 2783,
    y: 60,
  },
  {
    s: 1.0,
    x: 1519,
    y: 118,
  },
  {
    s: 1.0,
    x: 1071,
    y: 233,
  },
  {
    s: 1.0,
    x: 1773,
    y: 148,
  },
  {
    s: 1.0,
    x: 2098,
    y: 385,
  },
  {
    s: 1.0,
    x: 2423,
    y: 244,
  },
  {
    s: 1.0,
    x: 901,
    y: 385,
  },
  {
    s: 1.0,
    x: 624,
    y: 111,
  },
  {
    s: 1.0,
    x: 75,
    y: 103,
  },
  {
    s: 1.0,
    x: 413,
    y: 367,
  },
  {
    s: 1.0,
    x: 2895,
    y: 271,
  },
  {
    s: 1.0,
    x: 1990,
    y: 75,
  },
];

export const placeHolderImage =
  "https://upload.wikimedia.org/wikipedia/commons/9/99/Sample_User_Icon.png";

export const getFilter = (filterObject) => {
  let firebase = filterObject.superAdmin
    ? {
        collection: "adminAthletes",
        where: [["profilePublic", "==", true]],
        orderBy: ["lastName", "asc"],
      }
    : {
        collection: "athletes",
        where: [
          ["profilePublic", "==", true],
          ["committed", "==", false],
        ],
        orderBy: ["lastName", "asc"],
      };

  if (filterObject.filteredAcademics) {
    if (filterObject.filteredAcademics === "ACT") {
      firebase.where.push(["act", ">", 0]);
      firebase.orderBy = [
        ["act", "desc"],
        ["lastName", "asc"],
      ];
    } else if (filterObject.filteredAcademics === "SAT") {
      firebase.where.push(["sat", ">", 0]);
      firebase.orderBy = [
        ["sat", "desc"],
        ["lastName", "asc"],
      ];
    }
  }
  if (filterObject.filteredGradClass) {
    firebase.where.push(["class", "==", filterObject.filteredGradClass]);
  }
  if (
    filterObject.filteredPosition !== "None" &&
    filterObject.filteredPosition
  ) {
    firebase.where.push([
      "primaryPosition",
      "==",
      filterObject.filteredPosition,
    ]);
  }
  if (filterObject.filteredSport) {
    firebase.where.push(["sport", "==", filterObject.filteredSport]);
  }
  if (filterObject.showCommitted) {
    firebase.where = firebase.where.filter((value) => value[0] !== "committed");
    firebase.where.push(["committed", "==", true]);
  }

  return firebase;
};

export const getFilteredEvents = (sport, attenders, date, superAdmin) => {
  let firebase = superAdmin
    ? {
        collection: "events",
        where: [["eventStatus", "in", [true, false, null]]],
      }
    : {
        collection: "events",
        where: [["eventStatus", "==", true]],
      };
  if (sport) {
    firebase.where.push(["eventSport", "==", sport]);
  }
  if (attenders) {
    firebase.where.push(["eventAttenders", "array-contains", attenders]);
  }
  if (date) {
    firebase.where.push(["eventStartDate", "==", date]);
  }
  return firebase;
};

export const inEventCard = [
  {
    collection: "adminAthletes",
    storeAs: "athletes",
  },
  {
    collection: "advocates",
  },
];
export const roundToTwo = (num) => {
  return +(Math.round(num + "e+2") + "e-2");
};

export const array_move = (arr, old_index, new_index) => {
  while (old_index < 0) {
    old_index += arr.length;
  }
  while (new_index < 0) {
    new_index += arr.length;
  }
  if (new_index >= arr.length) {
    var k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr; // for testing purposes
};

export const removeFromArray = (arr, value) => {
  let i = 0;
  while (i < arr.length) {
    if (arr[i] === value) {
      arr.splice(i, 1);
    } else {
      ++i;
    }
  }
  return arr;
};
export const checkObjectIsEmpty = (obj) => {
  for (var key in obj) {
    if (obj[key] !== null && obj[key] !== "") return false;
  }
  return true;
};

export const bankAccountOptions = [
  { key: 1, text: "Checking account", value: "personal_checking" },
  { key: 2, text: "Business Checking account", value: "business_checking" },
  { key: 3, text: "Savings account", value: "personal_savings" },
  { key: 4, text: "Business Savings account", value: "business_savings" },
];

export const currentYear = Number(new Date().getFullYear());
export const currentMonth = Number(new Date().getMonth()) + 1;

export const allowedReasonCode = [
  "001",
  "000",
  "010",
  "805",
  "802",
  "801",
  "473",
  "470",
];
export const allowedReasonText = [
  "Info",
  "Approved",
  "Received",
  "Approved-TEST MODE",
  "Received-TEST MODE",
];
export const allowedResponseCode = ["Approved", "Received"];
export const isFileImage = (file) => {
  return file && file["type"].split("/")[0] === "image";
};

export const openURL = (fileURL) => {
  const pdfWindow = window.open();
  pdfWindow.location.href = fileURL;
};

export const mergeTypedArrays = (a, b) => {
  // Checks for truthy values on both arrays
  if (!a && !b) return [{ error: `${a} and ${b} is empty` }];

  // Checks for truthy values or empty arrays on each argument
  // to avoid the unnecessary construction of a new array and
  // the type comparison
  if (!b || b.length === 0) return a;
  if (!a || a.length === 0) return b;

  // Make sure that both typed arrays are of the same type
  if (Object.prototype.toString.call(a) !== Object.prototype.toString.call(b))
    return [
      {
        error:
          "The types of the two arguments passed for parameters a and b do not match.",
      },
    ];

  var c = new a.constructor(a.length + b.length);
  c.set(a);
  c.set(b, a.length);

  return c;
};

export const sliceIntoChunks = (arr, chunkSize) => {
  const res = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
    const chunk = arr.slice(i, i + chunkSize);
    res.push(chunk);
  }
  return res;
};

export const dateOptions = {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric",
};

export const randomName = (arr) => {
  const randomNumber = Math.floor(Math.random() * arr.length);
  return arr[randomNumber];
};
